// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__ox66E","marker":"Map_marker__pXh0s","myLocation":"Map_myLocation__3Qd9o","search":"Map_search__2r7WK"};